import { ReactElement, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../controls/Button';
import InputBox from '../../controls/InputBox';

/**
 * Header component.
 * @returns - React element that represents the Header component.
 */
function Header(): ReactElement {
  return (
    <div className="flex flex-col items-center">
      <div className="text-white text-2xl font-bold">
        <span className="text-primary-500">Step 3:</span> Configure devices
      </div>
      <div className="text-gray-400 mt-1">
        Set up your TelosAir device to start collecting real-time air quality data.
      </div>
    </div>
  );
}

/**
 * AddDevice component.
 * @returns - React element that represents the AddDevice component.
 */
export default function OnboardingConfigureDevice(): ReactElement {
  const navigate = useNavigate();
  const [serialNumber, setSerialNumber] = useState('');
  return (
    <div className="flex flex-col flex-1 justify-between items-center relative w-full">
      <button
        type="button"
        className="material-icons-outlined text-md cursor-pointer absolute top-0 left-0 text-white"
        onClick={() => navigate(-1)}
      >
        chevron_left
      </button>
      <Header />
      <div className="mt-5 flex flex-1 max-h-[40.813rem] flex-col rounded bg-container-500 w-[66.66vw]">
        <div className="flex items-center justify-between h-fit p-4 w-full bg-container-700 border-b border-gray-900">
          <div className="text-sm text-gray-600">
            Device List: <span className="text-gray-300">04 Devices</span> | Connected:{' '}
            <span className="text-gray-300">0</span>
          </div>
          <div className="flex gap-2">
            <div className="w-[18.5rem]">
              <InputBox
                noMarginTop
                idname="serial-number"
                value={serialNumber}
                onChnage={(value) => setSerialNumber(value)}
                placeholder="Serial Number"
              />
            </div>

            <Button
              name="Add Device"
              theme="secondary-gray"
              size="sm"
              onClick={() => {
                setSerialNumber('');
              }}
            />
          </div>
        </div>
        <div className="max-h-full overflow-y-auto">
          <table className="w-full border-collapse">
            <thead className="bg-container-700 font-medium text-gray-400 text-xs sticky top-0">
              <tr>
                <th className="h-11 text-center border-t border-b border-gray-900 w-1/4">
                  Serial Number
                </th>
                <th className="h-11 text-center border-t border-b border-gray-900 w-1/4">
                  Device No.
                </th>
                <th className="h-11 text-center border-t border-b border-gray-900 w-1/4">
                  Conn. Status
                </th>
                <th className="h-11 text-center border-t border-b border-gray-900 w-1/4">Action</th>
              </tr>
            </thead>
            <tbody className="text-gray-300 font-medium text-sm">
              <tr>
                <td className="h-20 text-center border-b border-gray-900">1234-1234-1234-1234</td>
                <td className="h-20 text-center border-b border-gray-900">Gateway - #1234</td>
                <td className="h-20 text-center border-b border-gray-900 text-success-500">
                  Active
                </td>
                <td className="h-20 text-center border-b border-gray-900">
                  <Button name="Configure" theme="secondary-color" size="sm" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="my-6 flex gap-2">
        <Button
          onClick={() => {
            navigate('/onboarding/add-groups');
          }}
          name="Next: Add groups"
          theme="primary"
          size="sm"
        />
        <Button
          onClick={() => {
            navigate('/onboarding/add-groups');
          }}
          name="Skip setup"
          theme="secondary-color"
          size="sm"
        />
      </div>
    </div>
  );
}
